import PropTypes from 'prop-types';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import ConfirmationFaq from '../components/ConfirmationPage/ConfirmationFaq';
import ConfirmationPrintView from '../components/ConfirmationPage/ConfirmationPrintView';
import ConfirmationScreenView from '../components/ConfirmationPage/ConfirmationScreenView';
import { selectConfirmationPageData } from '../selectors';

const ConfirmationPage = ({ route }) => {
  const { hasHighCompensation, hasTeraResponse, timestamp, submissionName } =
    useSelector(selectConfirmationPageData, shallowEqual);
  const { formConfig } = route ?? {};

  return (
    <div className="hca-confirmation-page vads-u-margin-bottom--2p5">
      <section className="screen-only">
        <ConfirmationScreenView
          {...{ formConfig, submissionName, timestamp }}
        />
      </section>

      <section className="print-only">
        <ConfirmationPrintView {...{ submissionName, timestamp }} />
      </section>

      <ConfirmationFaq {...{ hasHighCompensation, hasTeraResponse }} />

      <div className="screen-only vads-u-margin-y--4">
        <va-link-action
          text="Go back to VA.gov homepage"
          href="/"
          type="secondary"
        />
      </div>
    </div>
  );
};

ConfirmationPage.propTypes = {
  route: PropTypes.shape({
    formConfig: PropTypes.object,
  }),
};

export default ConfirmationPage;
